import { Box, Typography } from '@mui/material';
import React from 'react';
import { isDevApi, isDevMode } from '../../utils/environment';

export default function DevBanner() {
    if (isDevMode) {
        return (
            <Box
                style={{
                    position: 'fixed',
                    bottom: '25%',
                    right: 0,
                    zIndex: 9999,
                    backgroundColor: isDevApi ? 'red' : 'green',
                    color: 'white',
                    padding: '0.5rem',
                    textAlign: 'center',
                }}
            >
                <Typography>{isDevApi ? 'Dev' : 'Prod'} Server</Typography>
            </Box>
        );
    }

    return null;
}
